<template>
  <div class="container-fluid container-fluid px-4 rounded-4 contenedor-principal">
    <navegar-atras ruta="/soporte"></navegar-atras>
    <div class="row bg-white py-4 rounded-4">
      <ticket-detail :id="id" :es-backoffice="true"
        @ver-detalle-operacion="handleVerDetalleOperacion"
        @ver-detalle-borrador="handleVerDetalleBorrador"></ticket-detail>
    </div>
  </div>
</template>

<script setup lang="ts">
import NavegarAtras from "@/components/NavegarAtras.vue";
import TicketDetail from "@/.shared/components/soporte/TicketDetail.vue";
import { mostrarDetalleBorrador } from "@/services/OperacionDetalleModalFactory";
import { useRouter } from "@/.shared/services/routing-services";
import type { TipoOperacionEnum } from "@/.shared/enums/TipoOperacionEnum";
import { EntidadTicketEnum } from "@/.shared/components/soporte/models/EntidadTicketEnum";
import type { DetailTicketModel } from "@api/api";

const props = defineProps({
  id: {
    type: String,
    required: true
  }
})

const router = useRouter();

const handleVerDetalleOperacion = async (model: DetailTicketModel) => {
  const referencia = model.EntidadesAsociadas[EntidadTicketEnum.Operacion]?.[0];
  if (!referencia) return;

  const [idOperacion, tipoOperacion] = referencia.split("?tipo=");
  await router.push({ name: "tramite", query: { idOperacion, tipoOperacion: tipoOperacion as TipoOperacionEnum } });
};

const handleVerDetalleBorrador = async (model: DetailTicketModel) => {
  const referencia = model.EntidadesAsociadas[EntidadTicketEnum.Borrador]?.[0];
  if (!referencia) return;

  const idBorrador = referencia.split("?tipo=")[0];
  await mostrarDetalleBorrador(idBorrador);
};

</script>
